// extracted by mini-css-extract-plugin
export default {"correct":"PiGame_correct__e5ENA","incorrect":"PiGame_incorrect__thgKT","link":"PiGame_link__d0wRN","game":"PiGame_game__GOzLx","header":"PiGame_header__yctyn"};